<template>
  <div>
    <!-- 利用規約 -->
    <user-rule-detail-modal ref="userRuleDetailRef"
      :dispTitle="false"
    />
    <footer>
      <div>
      <span class="footer_downside">
        <ul>
          <li class="user_rule_detail" @click="showUserRuleDetailModal"> 利用規約</li>
          <!-- TODO 問い合わせの項目が足りないため一旦非表示 -->
          <!-- <li> | </li>-->
          <!-- <li><a @click="onClickContact" style="color:#fff">よくあるご質問</a></li>-->
        </ul>
      </span>
      <span class="footer_inc">
        <p>{{ copyright }}</p>
      </span>
      <span class="footer_logo">
        <p><img :src="getImage('component/common/header/domans_logo_white.svg')" alt="domans" width="120px" height="auto"></p>
      </span>
      </div>
    </footer>
  </div>
</template>
<script>
import * as App from '../../utils/App'
import UserRuleDetailModal from './UserRuleDetailModal'
export default {
  name: 'Footer',
  components: {
    'user-rule-detail-modal': UserRuleDetailModal
  },
  methods: {
    onClickContact: function () {
      App.showContactModal()
    },
    showUserRuleDetailModal: function () {
      this.$refs.userRuleDetailRef.showModal()
    },
    getImage: function (image) {
      return App.getDarosResource(image)
    }
  },
  data () {
    return {
      copyright: ''
    }
  },
  created: function () {
    var thisYear = new Date().getFullYear()
    this.copyright = 'Copyright & Patent 2000-%s Domans Inc. All Rights Reserved.'.replace('%s', thisYear)
  }
}
</script>
<style lang="scss" scoped>
.user_rule_detail {
  color:#fff;
  margin-left:20px;
  &:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/common/Footer.vue